"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INCOME_DISPARITY_THRESHOLD = exports.STATUSES = void 0;
exports.STATUSES = Object.freeze({
    UNVERIFIED: 'unverified',
    VERIFIED: 'verified'
});
exports.INCOME_DISPARITY_THRESHOLD = 2000;
